"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEip712TypedDataBasedOnChainId = exports.txEventsWithPreOnFulfill = void 0;
const cosmos_1 = require("@keplr-wallet/cosmos");
function txEventsWithPreOnFulfill(onTxEvents, preOnTxEvents) {
    const onBroadcasted = onTxEvents
        ? typeof onTxEvents === "function"
            ? undefined
            : onTxEvents.onBroadcasted
        : undefined;
    const onFulfill = onTxEvents
        ? typeof onTxEvents === "function"
            ? onTxEvents
            : onTxEvents.onFulfill
        : undefined;
    const onPreBroadcasted = preOnTxEvents
        ? typeof preOnTxEvents === "function"
            ? undefined
            : preOnTxEvents.onBroadcasted
        : undefined;
    const onPreFulfill = preOnTxEvents
        ? typeof preOnTxEvents === "function"
            ? preOnTxEvents
            : preOnTxEvents.onFulfill
        : undefined;
    if (!onBroadcasted && !onFulfill && !onPreBroadcasted && !onPreFulfill) {
        return undefined;
    }
    return {
        onBroadcasted: onBroadcasted || onPreBroadcasted
            ? (txHash) => {
                if (onPreBroadcasted) {
                    onPreBroadcasted(txHash);
                }
                if (onBroadcasted) {
                    onBroadcasted(txHash);
                }
            }
            : undefined,
        onFulfill: onFulfill || onPreFulfill
            ? (tx) => {
                if (onPreFulfill) {
                    onPreFulfill(tx);
                }
                if (onFulfill) {
                    onFulfill(tx);
                }
            }
            : undefined,
    };
}
exports.txEventsWithPreOnFulfill = txEventsWithPreOnFulfill;
const getEip712TypedDataBasedOnChainId = (chainId, msgs) => {
    const chainIsInjective = chainId.startsWith("injective");
    const { ethChainId } = cosmos_1.EthermintChainIdHelper.parse(chainId);
    const types = {
        types: Object.assign({ EIP712Domain: [
                { name: "name", type: "string" },
                { name: "version", type: "string" },
                { name: "chainId", type: "uint256" },
                // XXX: Maybe, non-standard format?
                { name: "verifyingContract", type: "string" },
                // XXX: Maybe, non-standard format?
                { name: "salt", type: "string" },
            ], Tx: [
                { name: "account_number", type: "string" },
                { name: "chain_id", type: "string" },
                { name: "fee", type: "Fee" },
                { name: "memo", type: "string" },
                { name: "msgs", type: "Msg[]" },
                { name: "sequence", type: "string" },
            ], Fee: [
                { name: "feePayer", type: "string" },
                { name: "amount", type: "Coin[]" },
                { name: "gas", type: "string" },
            ], Coin: [
                { name: "denom", type: "string" },
                { name: "amount", type: "string" },
            ], Msg: [
                { name: "type", type: "string" },
                { name: "value", type: "MsgValue" },
            ] }, msgs.rlpTypes),
        domain: {
            name: "Cosmos Web3",
            version: "1.0.0",
            chainId: ethChainId.toString(),
            verifyingContract: "cosmos",
            salt: "0",
        },
        primaryType: "Tx",
    };
    // Injective doesn't need feePayer to be included but requires
    // timeout_height in the types
    if (chainIsInjective) {
        types.types.Tx = [
            ...types.types.Tx,
            { name: "timeout_height", type: "string" },
        ];
        types.domain.name = "Injective Web3";
        types.domain.chainId = "0x" + ethChainId.toString(16);
        types.types.Fee = [
            { name: "amount", type: "Coin[]" },
            { name: "gas", type: "string" },
        ];
        return types;
    }
    // Return default types for Evmos
    return types;
};
exports.getEip712TypedDataBasedOnChainId = getEip712TypedDataBasedOnChainId;
//# sourceMappingURL=utils.js.map